import { IkeUnitAngle } from '@ikegps/core-api';

/** 2 * Math.Pi */
export const TWO_PI = Math.PI * 2;

/** Utility to help with working with angles */
export class IkeAngle {
	static RADIAN: typeof IkeUnitAngle.RADIAN = IkeUnitAngle.RADIAN;
	static DEGREE: typeof IkeUnitAngle.DEGREE = IkeUnitAngle.DEGREE;

	/**
	 * Case sensitive search for unit type
	 * @see IkeAngle.toUnitAngle
	 */
	static isUnitAngle(unit: string): unit is IkeUnitAngle {
		return unit === IkeAngle.RADIAN || unit === IkeAngle.DEGREE;
	}

	/** Case insensitive angle unit type search */
	static toUnitAngle(unit: string): IkeUnitAngle | null {
		let searchUnit = unit.toLowerCase();
		if (IkeAngle.isUnitAngle(searchUnit)) {
			return searchUnit;
		}
		return null;
	}
	/**
	 * Convert an angle to be between 0 and 2 * pi
	 * @param value Angle (Radians)
	 */
	static normalize(value: number) {
		return (value + TWO_PI) % TWO_PI;
	}

	/**
	 * Rotate an angle by pi
	 * @param value Angle (Radians)
	 */
	static flip(value: number) {
		return (value + Math.PI) % TWO_PI;
	}

	/**
	 * Convert an angle from degrees to radians
	 * @param degrees Angle (Degrees)
	 */
	static toRadians(degrees: number) {
		return degrees * (Math.PI / 180);
	}

	/**
	 * Convert an angle from radian to degrees
	 * @param radians Angle (Radians)
	 */
	static toDegrees(radians: number) {
		return radians * (180 / Math.PI);
	}
}
